import React from 'react';

interface EndChatButtonProps {
  onClick: () => void;
}

/**
 * Renders the button to initiate the end chat flow.
 */
export const EndChatButton: React.FC<EndChatButtonProps> = ({ onClick }) => {
  return (
    <div className="mt-2 text-center">
      <button
        onClick={onClick}
        className="text-sm text-gray-500 hover:text-gray-700"
      >
        End Chat & Get Email Updates
      </button>
    </div>
  );
}; 